// @flow

import * as React from 'react';
import cx from 'classnames';

import FAIcon from 'common/components/FAIcon';

import styles from './PreviewImage.scss';

import type { PreviewImageType } from './PreviewImages';

type Props = { image?: PreviewImageType, ... };

type State = { loading: boolean, ... };

type ButtonProps = { handleClick: () => void, ... };

function defaultPreventer(callback: () => void): MouseEvent => void {
  return e => {
    e.preventDefault;
    callback();
  };
}

export function NextButton(props: ButtonProps): React.Node {
  return (
    <button
      className={styles.nextButton}
      onClick={defaultPreventer(props.handleClick)}
    >
      <FAIcon name="angle-right" />
    </button>
  );
}

export function PreviousButton(props: ButtonProps): React.Node {
  return (
    <button
      className={styles.prevButton}
      onClick={defaultPreventer(props.handleClick)}
    >
      <FAIcon name="angle-left" />
    </button>
  );
}

export default class PreviewImage extends React.Component<Props, State> {
  loadingTimeout: TimeoutID;

  constructor() {
    super();

    this.state = {
      loading: true
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const { image: { url: currentUrl } = {} } = this.props;
    const { image: { url: nextUrl } = {} } = nextProps;

    clearTimeout(this.loadingTimeout);
    this.loadingTimeout = setTimeout(() => {
      this.setState({
        loading: currentUrl !== nextUrl
      });
    }, 500);
  }

  componentWillUnmount() {
    clearTimeout(this.loadingTimeout);
  }

  render(): React.Node {
    const { image = {} } = this.props;
    const renderImage = !!image.url;
    const backgroundImage = image.placeholder
      ? `url('${image.placeholder}')`
      : null;

    return (
      <div
        className={styles.previewImageWrapper}
        style={{
          backgroundImage: backgroundImage
        }}
      >
        {renderImage && (
          <img
            // TODO: Use proper alt attribute instead of data-testid
            data-testid={image.url}
            src={image.url}
            className={cx({
              [styles['previewImage']]: true,
              [styles['previewImage--loading']]: this.state.loading
            })}
            height="400"
            width="600"
            onLoad={this.imageLoaded}
          />
        )}
      </div>
    );
  }

  imageLoaded: () => void = () => {
    clearTimeout(this.loadingTimeout);
    this.setState({ loading: false });
  };
}
